<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="4">
						<el-form-item label="跟进人">
							<el-input v-model="searchParams.rname"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="缴费人">
							<el-input placeholder="请输入缴费人手机" v-model="searchParams.mobile"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="计划月份">
							<el-date-picker @change="search" value-format="yyyy-MM" v-model="searchParams.mth" type="month"
								placeholder="请输入计划缴费月份">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="状态">
							<select-option-dictionary @change="search" v-model="searchParams.result"
								dkey="xl-gjresult"></select-option-dictionary>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" v-has-permission-code-and="'003000450020'" size="mini" icon="el-icon-plus"
				@click="toSave()">添加</el-button>
			<el-button type="danger" v-has-permission-code-and="'003000450010'" size="mini" icon="el-icon-delete"
				@click="batchRemove()">批量删除</el-button>
			<el-button type="success" size="mini" icon="el-icon-merge" @click="consolidatedPaymentlist()">合并开票</el-button>

			<el-tag style="margin-left: 15px; " size="small" type="info" v-if="flag">总计{{ alllength }}项, 待交: {{ submit
			}}元/{{ submitnum }}项, 已完成:{{ complete }}元/{{ completenum }}项, 合计:{{ mergedata }}元</el-tag>
		</div>

		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
				v-loading="listLoading">

				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="gnneedtm" width="130" label="实际缴费">
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.gntm" type="success">{{ scope.row.gntm }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="gnneedtm" width="130" label="计划缴费">
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.gnneedtm" type="danger">{{ scope.row.gnneedtm }}</el-tag>
					</template>
				</el-table-column>
	
				<el-table-column prop="snm" width="90" label="缴费人"></el-table-column>
				<el-table-column prop="moblie" width="120" label="电话号码"></el-table-column>
				<el-table-column prop="username" width="90" label="跟进人"></el-table-column>
				<el-table-column prop="type" width="110" label="缴费类型"></el-table-column>
				<el-table-column prop="cost" width="110" label="金额"></el-table-column>
				<el-table-column prop="shouju" width="90" label="有收据">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.shouju" type="success">√</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="fapiaoid" width="90" label="已开票">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.fapiaoid" type="success">√</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="result" label="跟进状态"></el-table-column>



				<el-table-column label="操作" fixed="right" width="300px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" v-has-permission-code-and="'003000450000'"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" v-has-permission-code-and="'003000450005'"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" v-has-permission-code-and="'003000450010'"
								v-if="!scope.row.fapiaoid && !scope.row.shouju" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
							<el-button size="mini" v-has-permission-code-and="'003000450015'"
								v-if="!scope.row.fapiaoid && !scope.row.shouju" type="success"
								@click="ToUpload(scope.$index, scope.row)">上传</el-button>
							<!-- v-if="isShowUpload(scope.row)" -->
						</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 上传收据消息 -->
			<el-dialog title="上传收据信息" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
				<el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="80px">
					<el-row>
						<!-- <el-form-item label="上传发票" prop="fppic"></el-form-item> -->
						<el-col :span="12" class="userHead" style="margin-left: 30px;">
							<drag-file-upload @change="change" v-model="formParameter.shouju" drag uri="/statics/shouju"
								model="fileSystem" :size="10240"></drag-file-upload>
							<div style=" font-weight: bold;">
							</div>
						</el-col>

					</el-row>
				</el-form>

				<!-- <image-upload @change="change" v-model="formParameter.shouju" uri="/statics/shouju" model="fileSystem"
					:size="10240"></image-upload>-->


				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirm()">确 定</el-button>
				</span>

			</el-dialog>


			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<addfp ref="addfp"></addfp>
	</div>
</template>
<script>
import edit from './edit.vue';

import addfp from '../fapiao/add.vue';
import api from '@/api/xueli/xlsturecord.js';

import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import dragFileUpload from '@/components/biz/fileUpload/dragFileUpload.vue';


export default {
	name: 'xlsturecord',
	components: {
		edit,
		addfp,
		selectOptionDictionary,
		imageUpload,
		dragFileUpload,
	},
	data() {
		return {
			// 'type': '缴费'
			searchParams: {},
			formParameter: {},
			uploadParameter: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			mergedata: 0.0,
			alllength: 0,
			submit: 0.0,
			submitnum: 0,
			complete: 0.0,
			completenum: 0,
			flag: false,
			dialogVisible: false,
		};
	},
	methods: {
		isShowUpload(row) {
			if (row.result == '已完成') {
				if (!row.shouju) {
					return true
				}
			}
			return false
		},
		change(val) { },
		handleClose() { },
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {

				this.listData = response.data;
				this.listLoading = false;
				
			})
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			this.$refs.edit.open(row, '编辑');
		},
		//去详情
		toDetail(index, row) {

			this.$refs.edit.open(row, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		ToUpload(index, row) {
			this.uploadParameter = {
				id: row.id,
				snm: row.snm,
				cost: row.cost
			};
			this.dialogVisible = true;
		},
		//提交表单
		//提交表单
		confirm() {

			this.$utils.checkForm(this.$refs.form, () => {
				//添加
				this.formParameter.shouju = this.formParameter.shouju.substring( this.formParameter.shouju.indexOf('/statics/')  )
				let parameter = this.$utils.merger(this.formParameter, this.uploadParameter);
				api.upload(parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.dialogVisible = false;
						// this.close();
						// this.$parent.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);

					}
				);
				this.list();
			});

		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let ids = []
			this.selected.forEach(v => {
				ids.push(v.id)
			})

			let parameter = {
				ids: ids
			};

			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			let count = 0.0;
			let cou2 = 0.0;	//已完成
			let cou3 = 0.0;	//待交
			let len = 0;
			let len2 = 0;

			for (let item of val) {
				this.selected.push(item);
				count = count + Number.parseFloat(item.cost);
				if (item.result === "已完成") {
					cou2 = cou2 + Number.parseFloat(item.cost);
					len += 1;
				} else {
					cou3 = cou3 + Number.parseFloat(item.cost);
					len2 += 1;
				}
			}

			if (this.selected == null || this.selected.length <= 0) {
				this.flag = false;
				return;
			}

			this.alllength = this.selected.length;
			this.mergedata = count.toFixed(3);
			this.submit = cou3.toFixed(3);
			this.submitnum = len2;
			this.complete = cou2.toFixed(3);
			this.completenum = len;
			this.flag = true;
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = { 'type': '缴费' }
			this.list();
		},


		//合并缴费清单
		consolidatedPaymentlist() {

			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;

			}
			this.$utils.confirm.warning('提示', '确定合并吗？', () => {
				for (let item of this.selected) {
					if (item.fapiaoid) {
						// 失败
						this.$utils.msg.warning("请选择未开票的记录.");
						return false;
					}

					for (let row of this.selected) {
						if (row.moblie != item.moblie) {
							// 失败
							this.$utils.msg.warning("请选择同一缴费人进行合并开票.");
							return false;
						}
					}
				}

				this.$refs.addfp.open(this.selected, '添加合并开票');

			});
		},
		//统计合并起来的数据显示到页面中


	},

	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

